function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".i-lager-thin_svg__st0{fill:none;stroke:currentColor;stroke-width:inherit;stroke-linejoin:round;stroke-miterlimit:10}");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "i-lager-thin_svg__st0",
  d: "M.2 6C.2 2.8 2.8.3 5.9.3s5.7 2.6 5.7 5.7"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "i-lager-thin_svg__st0",
  d: "M.2 6c0 3.2 2.6 5.7 5.7 5.7s5.7-2.6 5.7-5.7"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "i-lager-thin_svg__st0",
  d: "M3.7 6.1l1.5 1.5 3-3.4"
});

function SvgILagerThin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "i-lager-thin_svg__Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 11.9 11.9",
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgILagerThin;